module.exports = __webpack_public_path__ + "media/images/flags/sr-5ecefc1b6c456d04472733c137c2fc2f.svg";